import { inject } from '@angular/core';
import type { CanActivateChildFn, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { map } from 'rxjs';
import { BillingSubscriptionGateService } from './billing-subscription-gate.service';

/**
 * Rotas liberadas mesmo com a assinatura travada (paywall — D1/W1-2): a própria tela de planos
 * (onde o negócio resolve o bloqueio), o Perfil (trocar de empresa / sair) e Cobrança (cadastrar
 * cartão — reativar um plano pago exige método de pagamento já salvo). Sem isso o guard criaria
 * um loop de redirecionamento infinito ao mandar pra `/configuracoes/assinatura/planos`.
 */
const PAYWALL_ALLOWLIST = ['/configuracoes/assinatura', '/configuracoes/perfil', '/configuracoes/cobranca'];

function isAllowlisted(url: string): boolean {
  return PAYWALL_ALLOWLIST.some((prefix) => url === prefix || url.startsWith(`${prefix}/`) || url.startsWith(`${prefix}?`));
}

/**
 * `canActivateChild` no shell autenticado: bloqueia TODA navegação quando a assinatura está
 * `expired`/`suspended`/`cancelled`, redirecionando pra "Ver planos". Não bloqueia por
 * `subscription === null` (conta sendo provisionada — ver `BillingSubscriptionGateService`) nem
 * por `past_due` (opera na graça, mesmo critério do backend).
 */
export const billingPaywallGuard: CanActivateChildFn = (_childRoute, state: RouterStateSnapshot) => {
  const gate = inject(BillingSubscriptionGateService);
  const router = inject(Router);

  if (isAllowlisted(state.url)) return true;

  return gate.ensureCheckedIsBlocked().pipe(
    map((blocked) => (blocked ? router.parseUrl('/configuracoes/assinatura/planos') : true)),
  );
};
